import List from "@/components/list";
import router from "@/router";
import moment from "moment";
import Bus from "./Bus.js";
// import { noticeDel } from "@/api/notice";
// import "./table.css";

const Table = (args) => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};

  const shareManage = args.listeners["shareManage"] || function() {};

  function deleteNotice(data) {
    Bus.$emit("deleteNotice", data);
  }
  function setUp(data, type) {
    Bus.$emit("setUp", { id: data, status: type });
  }
  function setDown(data, type) {
    Bus.$emit("setUp", { id: data, status: type });
  }
  function setTop(data, type) {
    Bus.$emit("setTop", { id: data, status: type });
  }
  function editNotice(data) {
    router.push({
      path: "/notice/edit",
      query: {
        uuid: data.uuid,
      },
    });
  }

  function toNoticeDetail(data) {
    router.push({
      path: "/notice/detail",
      query: {
        uuid: data.uuid,
      },
    });
  }

  const Datevo = ({ props: { vo } }) => {
    const notice = vo.row;
    if (
      new Date(notice.expireTime).getTime() >=
      new Date(moment().format("YYYY-MM-DD")).getTime()
    ) {
      return <div>{notice.expireTime}</div>;
    } else {
      return <div class="red-font">{notice.expireTime}</div>;
    }
  };
  const Deal = ({ props: { vo } }) => {
    const item = vo.row;
    let dealConf = [];

    if (
      new Date(item.expireTime).getTime() >=
      new Date(moment().format("YYYY-MM-DD")).getTime()
    ) {
      // 下线并且能分享可以进行修改
      if (item.onlineStatus == 0 && item.canShare == 1) {
        dealConf.push([
          "icon-edit",
          "修改",
          () => editNotice(item),
          "notice:update",
        ]);
      } else {
        dealConf.push(["icon-edit-disable", "修改", () => {}, "notice:update"]);
      }
      if (item.onlineStatus == 1) {
        dealConf.push([
          "icon-delete-disable",
          "删除",
          () => {},
          "notice:delete",
        ]);
        dealConf.push([
          "icon-down",
          "下线",
          () => setDown(item.uuid, 0),
          "notice:online",
        ]);
      } else {
        dealConf.push([
          "icon-delete",
          "删除",
          () => deleteNotice(item.uuid),
          "notice:delete",
        ]);
        dealConf.push([
          "icon-up",
          "上线",
          () => setUp(item.uuid, 1),
          "notice:online",
        ]);
      }

      if (item.setTop == 1) {
        dealConf.push([
          "icon-cancel",
          "取消置顶",
          () => setTop(item.uuid, 0),
          "notice:top",
        ]);
      } else {
        dealConf.push([
          "icon-top",
          "置顶",
          () => setTop(item.uuid, 1),
          "notice:top",
        ]);
      }

      if (item.canShare == 1) {
        dealConf.push([
          "icon-share",
          "共享管理",
          () => shareManage(item),
          "notice:shareList",
        ]);
      } else {
        dealConf.push([
          "icon-share-none",
          "共享管理",
          () => {},
          "notice:shareList",
        ]);
      }
    } else {
      dealConf.push(["icon-edit-disable", "修改", () => {}, "notice:update"]);
      dealConf.push(["icon-delete", "删除", () => deleteNotice(item.uuid), "notice:delete"]);
    }
    
    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip
            class="item"
            effect="dark"
            content={item[1]}
            placement="top"
            v-permission={item[3]}
          >
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const NoticeTitle = ({ props: { vo } }) => {
    const item = vo.row;
    return (
      <div class="base-hover-char" onClick={() => toNoticeDetail(item)}>
        {item.noticeTitle}
      </div>
    );
  }

  function selectable(row, index) {
    if (
      new Date(row.expireTime).getTime() <
      new Date(moment().format("YYYY-MM-DD")).getTime()
    ) {
      return false;
    }
    return true;
  }

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
      selectable: selectable,
    },
    {
      label: "公告标题",
      prop: "noticeTitle",
      minWidth: "150",
      showOverflowTooltip: true,
      render: (vo) => <NoticeTitle vo={vo} />,
    },
    
    {
      label: "创建者",
      prop: "createUserName",
      width: "120",
      showOverflowTooltip: true,
    },
    {
      label: "是否置顶",
      prop: "setTopName",
      width: "80",
      showOverflowTooltip: true,
    },
    {
      label: "过期日期",
      prop: "expireTime",
      sortable: true,
      width: "150",
      render: (vo) => <Datevo vo={vo} />,
    },
    {
      label: "版权方",
      prop: "originDeptName",
      minWidth: "100"
    },
    {
      label: "已共享学院",
      prop: "sharedDeptNames",
      minWidth: "120"
    },
    {
      label: "最后更新",
      prop: "modifyDate",
      sortable: true,
      width: "180",
      showOverflowTooltip: true,
    },
    {
      label: "状态",
      prop: "onlineStatusName",
      width: "80",
      showOverflowTooltip: true,
    },
    {
      label: "操作",
      width: "180",
      fixed: "right",
      render: (vo) => <Deal vo={vo} />,
    },
  ];

  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
